const MobileInterface = {
  getClientPlatformType() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.getClientPlatformType());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.getClientPlatformType.postMessage(null);

          function clientPlatformTypeHandler(event) {
            resolve(event.detail);
            window.removeEventListener('clientPlatformTypeResponse', clientPlatformTypeHandler);
          }

          window.addEventListener('clientPlatformTypeResponse', clientPlatformTypeHandler);

        } catch (error) {
          //fallback for web
          resolve("web");
        }
      }

    })
  },

  getClientVersion() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.getClientVersion());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.getClientVersion.postMessage(null);

          function clientVersionHandler(event) {
            resolve(event.detail);
            window.removeEventListener('clientVersionResponse', clientVersionHandler);
          }

          window.addEventListener('clientVersionResponse', clientVersionHandler);

        } catch (error) {
          //fallback
          resolve("1.0");
        }
      }

    })
  },

  checkLocationPermission() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.checkLocationPermission());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.checkLocationPermission.postMessage(null);

          function handler(event) {

            if (event.detail === 'yes') {
              resolve(true);
            } else {
              resolve(false);
            }

            window.removeEventListener('checkLocationPermissionResponse', handler);
          }

          window.addEventListener('checkLocationPermissionResponse', handler);

        } catch (error) {
          //fallback for web
          resolve(Boolean(navigator.geolocation));
        }
      }

    })
  },

  requestLocationPermission() {
    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.requestLocationPermission()
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.requestLocationPermission.postMessage(null);

      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  

  logOut() {
    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.logOut()
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.logOut.postMessage(null);

      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  showLocationSettingsAlert() {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.showLocationSettingsAlert()
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.showLocationSettingsAlert.postMessage(null);

      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  openLink(url) {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.openLink(url)
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.openLink.postMessage(url);
      } catch (error) {
        //fallback
        window.open(url, '_blank');
      }
    }
  },

  

  setOneSignalExternalUserId(id) {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.setOneSignalExternalUserId(id);
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.setOneSignalExternalUserId.postMessage(id);
      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  isLocationEnabled() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.isLocationEnabled());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.isLocationEnabled.postMessage(null);

          function handler(event) {
            if (event.detail === 'yes') {
              resolve(true);
            } else {
              resolve(false);
            }

            window.removeEventListener('isLocationEnabledResponse', handler);
          }

          window.addEventListener('isLocationEnabledResponse', handler);

        } catch (error) {
          //fallback for web
          resolve(Boolean(navigator.geolocation));
        }
      }

    })
  },

  requestCurrentLocation() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.requestCurrentLocation());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.requestCurrentLocation.postMessage(null);

          function handler(event) {
            resolve(event.detail);
            window.removeEventListener('requestCurrentLocationResponse', handler);
          }

          window.addEventListener('requestCurrentLocationResponse', handler);

        } catch (error) {
          //fallback for web
          if (navigator.geolocation) {
            
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const { latitude, longitude } = position.coords;
                const userLocation = { lat: latitude, lng: longitude };
                resolve(JSON.stringify(userLocation));
                return;
              },
              (error) => {
                console.error('Error detecting location:', error.message);
                resolve("unavailable");
              }
            );
          } else {
            resolve("unavailable");
          }
        }
      }

    })
  },

  getQrScanResult() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.getQrScanResult());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.getQrScanResult.postMessage(null);

          function handler(event) {
            resolve(event.detail);
            window.removeEventListener('getQrScanResultResponse', handler);
          }

          window.addEventListener('getQrScanResultResponse', handler);

        } catch (error) {
          //fallback for web
          
          resolve("");
        }
      }

    })
  },
}

export default MobileInterface;
